export default "__VITE_ASSET__afdbc886__"